import React, { useState, useEffect } from "react";
import {
  Container,
  Grid,
  Box,
  Typography,
  Card,
  CardContent,
  useTheme,
  Paper
} from "@mui/material";
import { NavLink, useNavigate } from "react-router-dom";
import { axiosInstance } from "../Api/instance";
import { showWarning } from "../../utils/popup";

// Assets imports
import Test from "../../asserts/flexibility.png";
import Subject from "../../asserts/test.png";
import Discussion from "../../asserts/communication.png";
import MCQ from "../../asserts/online.png";
import Note from "../../asserts/test (2).png";
import Test1 from "../../asserts/test (1).png";
import Crown from "../../asserts/crown.png";
import Prelims from "../../asserts/aiims.png";
import Mains from "../../asserts/mains.png";

const MyComponent = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const Navigate = useNavigate();
  const [profileData, setProfileData] = useState([]);
  const email = localStorage.getItem("userMail");
  const plan = localStorage.getItem("category");

  useEffect(() => {
    fetchProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchProfile = async () => {
    try {
      const response = await axiosInstance.post(`get/U_ViewProfile.php`, {
        email: email,
      });
      setProfileData(response.data);
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  const handleHybridClick = (e) => {
    const isPremium = profileData.length > 0 && plan === "premium";
    if (isPremium) {
      Navigate("/hybrid");
    } else {
      showWarning("Please subscribe to continue premium");
      Navigate("/plan");
    }
  };

  const categories = [
    {
      title: "Previous MCQ",
      img: Note,
      path: "/year",
      premium: false
    },
    {
      title: "Subject_wise MCQ",
      img: Subject,
      path: "/subject",
      premium: false
    },
    {
      title: "Non_nursing MCQ",
      img: MCQ,
      path: "/non_nursing",
      premium: false
    },
    {
      title: "Model_mock Test",
      img: Test1,
      path: "/model",
      premium: false
    },
    {
      title: "Hybrid Test",
      img: Test,
      action: handleHybridClick,
      premium: true
    },
    {
      title: "Discussion Forum",
      img: Discussion,
      path: "/discussion",
      premium: false
    },
    {
      title: "Aiims Prelims",
      img: Prelims,
      path: "/prelims",
      premium: false
    },
    {
      title: "Aiims Mains",
      img: Mains,
      path: "/mains",
      premium: false // Keeps hidden visibility as per original codebase
    }
  ];

  return (
    <Box 
      sx={{ 
        bgcolor: isDark ? "rgba(11, 15, 25, 0.5)" : "#E8F5EC", 
        py: { xs: 6, md: 8 }, 
        px: { xs: 2, md: 4 },
        transition: "all 0.3s ease"
      }}
    >
      <Container maxWidth="lg">
        {/* Title */}
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 800,
              letterSpacing: "0.08em",
              color: isDark ? "primary.main" : "#183A1D",
              textTransform: "uppercase",
              fontSize: { xs: "1.8rem", md: "2.4rem" }
            }}
          >
            Categories
          </Typography>
          <Box 
            sx={{ 
              width: "60px", 
              height: "4px", 
              bgcolor: isDark ? "primary.main" : "#183A1D", 
              mx: "auto", 
              mt: 1.5,
              borderRadius: "2px"
            }} 
          />
        </Box>

        {/* Grid of Categories */}
        <Grid container spacing={3} justifyContent="center">
          {categories.map((cat, idx) => {
            const cardContent = (
              <Card
                elevation={0}
                sx={{
                  height: "220px",
                  borderRadius: "20px",
                  bgcolor: "background.paper",
                  border: `1px solid ${isDark ? "rgba(255, 255, 255, 0.06)" : "rgba(0, 0, 0, 0.05)"}`,
                  boxShadow: isDark 
                    ? "0 4px 20px rgba(0, 0, 0, 0.3)" 
                    : "0 4px 20px rgba(99, 99, 99, 0.05)",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                  overflow: "hidden",
                  "&:hover": {
                    transform: "translateY(-8px)",
                    boxShadow: isDark 
                      ? "0 12px 30px rgba(0, 0, 0, 0.5)" 
                      : "0 12px 30px rgba(99, 99, 99, 0.12)",
                    borderColor: isDark ? "primary.main" : "success.light",
                    "& .cat-image": {
                      transform: "scale(1.1)",
                    }
                  }
                }}
              >
                {/* Premium Banner */}
                {cat.premium && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: 12,
                      right: 12,
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                      px: 1.2,
                      py: 0.5,
                      borderRadius: "8px",
                      bgcolor: isDark ? "rgba(217, 119, 6, 0.15)" : "rgba(251, 191, 36, 0.12)",
                      border: `1px solid ${isDark ? "rgba(217, 119, 6, 0.3)" : "rgba(251, 191, 36, 0.4)"}`,
                    }}
                  >
                    <img src={Crown} height="14px" alt="Crown" />
                    <Typography 
                      variant="caption" 
                      sx={{ 
                        fontWeight: 700, 
                        color: isDark ? "#FBBF24" : "#B45309",
                        fontSize: "10px"
                      }}
                    >
                      PREMIUM
                    </Typography>
                  </Box>
                )}

                <CardContent sx={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%", p: 3 }}>
                  {/* Category Image */}
                  <Box 
                    sx={{ 
                      width: "80px", 
                      height: "80px", 
                      display: "flex", 
                      alignItems: "center", 
                      justifyContent: "center",
                      mb: 2
                    }}
                  >
                    <img 
                      className="cat-image"
                      src={cat.img} 
                      height="64px" 
                      alt={cat.title} 
                      style={{ 
                        objectFit: "contain",
                        transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)" 
                      }} 
                    />
                  </Box>
                  
                  {/* Title */}
                  <Typography 
                    variant="h6" 
                    sx={{ 
                      fontWeight: 700, 
                      textAlign: "center", 
                      color: "text.primary",
                      fontSize: "1.05rem"
                    }}
                  >
                    {cat.title}
                  </Typography>
                </CardContent>
              </Card>
            );

            return (
              <Grid item xs={12} sm={6} md={4} lg={3} key={idx}>
                {cat.action ? (
                  <Box onClick={cat.action}>
                    {cardContent}
                  </Box>
                ) : (
                  <NavLink to={cat.path} style={{ textDecoration: "none" }}>
                    {cardContent}
                  </NavLink>
                )}
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </Box>
  );
};

export default MyComponent;
